import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'app-modal-comment',
  templateUrl: './modal-comment.component.html',
  styles: []
})
export class ModalCommentComponent extends ExcTranslation implements OnInit {

  data = {Comment: null};
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService) {
    super();

  }
  proceed() {
    this.overlayRef.close({proceed: true, Comment: this.data.Comment});
  }
  ngOnInit() {
    this.data.Comment = this.overlayConfig.data.Comment;
  }
}
